module.exports = __webpack_public_path__ + "static/media/uplands_masterdeed_bylaws.df979d7a.pdf";